// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pf4X5","textarea":"styles_textarea__Ca1hf"};